import React from 'react'
import { LayoutBand, H1, Row, MarginBox, Card, Grid, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { baseUrl } from '@fs/zion-config'
import { i18n } from '@fs/zion-locale'
import AuthoritiesAppPageHead from '../../AuthoritiesAppPageHead'

export default function EditorRightsRequestsPage(): JSX.Element {
  usePageView({ page_detail: 'EditorRightsRequests' })
  const [t] = useTranslation()

  return (
    <>
      <AuthoritiesAppPageHead
        title={t('editor-rights-requests-page.page-title', 'Editor Rights Requests')}
        description={t(
          'editor-rights-requests-page.page-description',
          'Manage editor rights requests for place authorities'
        )}
        canonicalUrl={`${baseUrl}/${i18n.language}/standards/editor-rights-requests/`}
      />
      <LayoutBand
        maxWidth="xxl"
        marginY="nano"
        marginX="nano"
        style={{ height: 'calc(100vh - 70px)', background: colors.gray02 }}
      >
        <div style={{ height: '100%' }}>
          <Grid gutters="xxs">
            <Card columns={12} margins="dense">
              <MarginBox marginX="nano" marginY="nano">
                <Row wrap alignItemsY="middle">
                  <H1 size="H3" growX>
                    {t('editor-rights-requests-page.heading', 'Editor Rights Requests')}
                  </H1>
                </Row>
              </MarginBox>
            </Card>
            <Card columns={12} margins="dense">
              <MarginBox marginX="nano" marginY="nano">
                <div style={{ marginBottom: '16px', fontSize: '14px', lineHeight: '1.5' }}>
                  <p style={{ margin: 0 }}>
                    {t(
                      'editor-rights-requests-page.instructions-line1',
                      'You must be signed into your FamilySearch Microsoft account to access this form. If you need access, please reach out to the Authorities team.'
                    )}
                  </p>
                  <p style={{ margin: 0 }}>
                    {t(
                      'editor-rights-requests-page.instructions-line2',
                      'Each form submission is for a single user. If you are requesting rights for multiple users, submit a new form for each one.'
                    )}
                  </p>
                </div>
                <iframe
                  src="https://forms.office.com/Pages/ResponsePage.aspx?id=s-7mYddfqkquPGHo3rCbebE-7yXjlJJLl6XSHDvrDllURDMyMTdPRFFJSko2T1I1WUgyME44SE4yQyQlQCN0PWcu"
                  width="100%"
                  height="800px"
                  sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-top-navigation-by-user-activation"
                  title={t('editor-rights-requests-page.form-title', 'Editor Rights Request Form')}
                  style={{ border: 'none', margin: 0 }}
                >
                  {t('editor-rights-requests-page.loading', 'Loading form...')}
                </iframe>
              </MarginBox>
            </Card>
          </Grid>
        </div>
      </LayoutBand>
    </>
  )
}
